// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1EUXX","alertIcon":"ConfirmModal_alertIcon__1WXZx"};